import styled from "styled-components"

const Wrapper = styled.div`
  border-bottom: solid 1px rgba(0, 0, 0, 0.15);
  border-top: solid 1px rgba(0, 0, 0, 0.15);
`

const Head = styled.h3`
  display: block;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  margin: 20px 0;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 18px;
    margin: 25px 0;
  }
`

const Swiper = styled.div`
  .swiper-container {
    width: 100%;
  }

  .swiper-wrapper {
    @media only screen and (min-width: ${props => props.theme.mq.xsmall}) {
      flex-wrap: wrap;
    }
  }

  .swiper-slide {
    display: flex;
    flex-wrap: wrap;

    @media only screen and (min-width: ${props => props.theme.mq.xsmall}) {
      margin: 0 -12.5px;
      padding-bottom: 35px;
    }

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      margin: 0 -17.5px;
      padding-bottom: 50px;
    }

    &:only-child{
      @media only screen and (max-width: calc(${props => props.theme.mq.xsmall} - 1px)) {
        padding-bottom: 35px;
      }
    }

    > div {
      flex: 0 0 auto;
      width: 100%;

      @media only screen and (min-width: ${props => props.theme.mq.xsmall}) {
        padding: 0 12.5px;
        width: 50%;
      }

      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        padding: 0 17.5px;
      }
    }
  }

  .swiper-pagination {
    margin-bottom: 20px;

    @media only screen and (min-width: ${props => props.theme.mq.xsmall}) {
      display: none;
    }
  }
`

const Image = styled.div`
  img {
    display: block;
    height: auto;
    width: 100%;
  }
`

const Caption = styled.div` 
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: calc(${props => props.theme.mq.xsmall} - 1px)) {
    margin-top: 12px;
  }
`

const Tag = styled.span`
  align-self: flex-start;
  border: 1px solid #ccc;
  border-radius: 10px;
  color: #858585;
  display: inline-block;
  font-size: 11px;
  line-height: 1.5;
  margin-bottom: 10px;
  padding: 1px 10px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 12px;
  }
`

const Title = styled.h4`
  font-size: 14px;
  font-weight: ${props => props.theme.title.w};
  line-height: ${props => props.theme.title.lhd};

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 16px;
  }
`

const Desc = styled.p`
  color: #858585;
  font-size: 11px;
  line-height: 1.4;
  margin: 5px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 12px;
    margin: 10px 0 0;
  }
`

const Info = styled.div`
  color: #858585;
  font-size: 12px;
  margin: 5px 0 20px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 13px;
    margin: 10px 0 30px;
  }

  span {
    color: ${props => props.theme.colors.grey};

    strong {
      font-size: 16px;
      font-weight: ${props => props.theme.title.w};

      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        font-size: 18px;
      }
    }
  }
`

const Button = styled.a`
  align-items: center;
  align-self: flex-start;
  background-color: ${props => props.theme.colors.primary};
  border-radius: 5px;
  color: #fff;
  display: inline-flex;
  font-size: 13px;
  font-weight: ${props => props.theme.title.w};
  height: 40px;
  justify-content: center;
  margin-top: auto;
  min-width: 150px;
  padding: 0 20px;
  transition: opacity .3s;

  @media only screen and (max-width: calc(${props => props.theme.mq.xsmall} - 1px)) {
    width: 100%;
  }

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 14px;
    height: 50px;
    min-width: 205px;
  }

  .no-touchevents &:hover {
    opacity: .7;
  }
`

export const sTrip = {
  Wrapper,
  Head,
  Swiper,
  Image,
  Caption,
  Tag,
  Title,
  Desc,
  Info,
  Button,
}
